import { PatientsList } from '../components/PatientsList/PatientsList';
import styles from './PatientsPage.module.css';

// Patients moved out of settings into the main navigation: entering a new
// patient and looking up preferences is daily planning work, not configuration.
export const PatientsPage = () => (
  <main className={styles.patientsPage}>
    <PatientsList />
  </main>
);
